module.exports = __webpack_public_path__ + "media/images/icons/phone-red-85b37957a0accf157987eabb9f822906.png";